export enum Skus {
  SEOMinute = "SEO-MINUTE",
  BusinessProfileManagement = "BUSINESS-PROFILE-MANAGEMENT",
}